import { colors } from '@fairygodboss/ui/index.umd';
import React, { useEffect, useRef, useState } from 'react';
import { useAudioPlayer } from './AudioPlayerProvider';

const VolumeIconSvg = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 5.00005V19.0001C12 19.891 10.9229 20.3371 10.2929 19.7072L6.58579 16.0001H3C2.44772 16.0001 2 15.5523 2 15.0001V9.00005C2 8.44777 2.44772 8.00005 3 8.00005H6.58579L10.2929 4.29294C10.9229 3.66298 12 4.10915 12 5.00005ZM16.1198 4.52538C16.382 4.03928 16.9886 3.85773 17.4747 4.11989C20.232 5.60695 22 8.63907 22 12.0001C22 15.361 20.232 18.3932 17.4747 19.8802C16.9886 20.1424 16.382 19.9608 16.1198 19.4747C15.8577 18.9886 16.0392 18.382 16.5253 18.1199C18.6285 16.9856 20 14.6334 20 12.0001C20 9.36665 18.6285 7.01446 16.5253 5.88021C16.0392 5.61806 15.8577 5.01148 16.1198 4.52538ZM10 7.41427L7.70711 9.70716C7.51957 9.89469 7.26522 10.0001 7 10.0001H4V14.0001H7C7.26522 14.0001 7.51957 14.1054 7.70711 14.2929L10 16.5858V7.41427ZM14.0923 8.58045C14.324 8.07914 14.9183 7.8606 15.4196 8.09234C16.979 8.81319 18 10.3141 18 12.0001C18 13.686 16.979 15.1869 15.4196 15.9078C14.9183 16.1395 14.324 15.921 14.0923 15.4197C13.8606 14.9183 14.0791 14.3241 14.5804 14.0923C15.4513 13.6898 16 12.8831 16 12.0001C16 11.117 15.4513 10.3103 14.5804 9.90776C14.0791 9.67602 13.8606 9.08177 14.0923 8.58045Z"
            fill="white"
        />
    </svg>
);

const MuteIconSvg = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 5.00005V19.0001C12 19.891 10.9229 20.3371 10.2929 19.7072L6.58579 16.0001H3C2.44772 16.0001 2 15.5523 2 15.0001V9.00005C2 8.44777 2.44772 8.00005 3 8.00005H6.58579L10.2929 4.29294C10.9229 3.66298 12 4.10915 12 5.00005ZM10 7.41427L7.70711 9.70716C7.51957 9.89469 7.26522 10.0001 7 10.0001H4V14.0001H7C7.26522 14.0001 7.51957 14.1054 7.70711 14.2929L10 16.5858V7.41427ZM15.7071 8.29294L18 10.5851L20.2929 8.29294C20.6534 7.93246 21.2206 7.90473 21.6129 8.20976L21.7071 8.29294C22.0676 8.65343 22.0953 9.22066 21.7903 9.61295L21.7071 9.70716L19.415 12.0001L21.7071 14.2929C22.0976 14.6835 22.0976 15.3166 21.7071 15.7072C21.3166 16.0977 20.6834 16.0977 20.2929 15.7072L18 13.4151L15.7071 15.7072C15.3466 16.0676 14.7794 16.0954 14.3871 15.7903L14.2929 15.7072C13.9324 15.3467 13.9047 14.7794 14.2097 14.3872L14.2929 14.2929L16.585 12.0001L14.2929 9.70716C13.9024 9.31663 13.9024 8.68347 14.2929 8.29294C14.6834 7.90242 15.3166 7.90242 15.7071 8.29294Z"
            fill="white"
        />
    </svg>
);

export const Volume = () => {
    const {
        volume,
        handleVolumeChange,
        setVolumeCollapse,
        mute,
        handleMute,
    } = useAudioPlayer();
    const [openVolumeBar, setOpenVolumeBar] = useState(false);
    const wrapperRef = useRef();

    useEffect(() => {
        setVolumeCollapse(openVolumeBar);
    }, [openVolumeBar, setVolumeCollapse]);

    const handleVolumeEvent = (bool) => {
        if (!window?.matchMedia('(pointer: coarse)').matches) {
            setOpenVolumeBar(bool);
        }
    };

    return (
        <div
            className="volume-slider-container"
            style={{
                display: 'flex',
                marginRight: '16px',
                alignItems: 'center',
                position: 'absolute',
                right: '22px',
            }}
            ref={wrapperRef}
            onMouseEnter={() => handleVolumeEvent(true)}
            onMouseLeave={() => handleVolumeEvent(false)}
        >
            <div
                style={{
                    backgroundColor: openVolumeBar ? colors.secondary[50] : '',
                    paddingLeft: '8px',
                    paddingRight: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: '30px',
                    cursor: 'pointer',
                }}
            >
                <div
                    className="volume-slider-div"
                    style={{
                        width: openVolumeBar ? 'inherit' : '0px',
                        overflow: 'hidden',
                        marginTop: '-2px',
                    }}
                >
                    <input
                        className={`volume-slider${
                            openVolumeBar ? ' extended' : ''
                        }`}
                        aria-label="Volume"
                        type="range"
                        min={0}
                        max={1}
                        step="any"
                        value={volume}
                        onChange={handleVolumeChange}
                    />
                </div>
                <div
                    className="volume-button"
                    tabIndex={0}
                    aria-label="Volume"
                    role="button"
                    onKeyPress={handleMute}
                    onClick={handleMute}
                    style={{ paddingTop: '6px' }}
                >
                    {mute ? <MuteIconSvg /> : <VolumeIconSvg />}
                </div>
            </div>
        </div>
    );
};
